module.exports = __webpack_public_path__ + "img/about_life.5713e9d9.png";